import { parseClientEnv } from '@disenchantment/config/client';
import { createSupabaseAuthClient } from '@disenchantment/auth-client';

const env = parseClientEnv(import.meta.env);

export const supabase = createSupabaseAuthClient(env.VITE_SUPABASE_URL, env.VITE_SUPABASE_ANON_KEY);
